export function createListOfMonths(startDate: Date, endDate: Date) {
  const interval = [];

  let currentMonth = startDate.getMonth();
  let currentYear = startDate.getFullYear();

  while (
    currentYear < endDate.getFullYear() ||
    (currentYear === endDate.getFullYear() &&
      currentMonth <= endDate.getMonth())
  ) {
    interval.push({
      month: currentMonth + 1,
      year: currentYear,
    });

    currentMonth++;
    if (currentMonth === 12) {
      currentMonth = 0;
      currentYear++;
    }
  }

  return interval;
}
